import React from "react";
import LayoutDashboard from "../layout/LayoutDashboard";
import { Icon } from '@iconify/react';
import searchOutlined from '@iconify/icons-ant-design/search-outlined';
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const Notfication = () => {
  return (
    <>
      <LayoutDashboard>
        <section className="ml-4 w-full">
          <div className="md-flex">
            <div className="bg-white">
              <div class="mb-4">
                <div className="flex align-middle rounded-tl-lg rounded-tr-lg w-full py-4 overflow-hidden bg-white shadow-lg px-12">
                  <div class="flex">
                    <input
                      class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                      type="text"
                      placeholder="Pencarian"
                      aria-label="Full name"
                    />
                    <button className="bg-green-100 text-white font-bold py-2 px-4 rounded">
                      <Icon
                        icon={searchOutlined}
                        className="text-2xl text-white"
                      />
                    </button>
                  </div>
                  <button className="bg-orange-500 text-white font-bold py-2 px-4 rounded ml-auto">
                    <Link to="/create-notification">
                    + Tambah Pemberitahuan
                    </Link>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="md-flex">
            <div className="bg-white">
              <div className="py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 pr-10 lg:px-8">
                <div className="align-middle rounded-tl-lg rounded-tr-lg inline-block w-full py-4 overflow-hidden bg-white shadow-lg px-12"></div>
                <div className="align-middle inline-block w-full shadow overflow-hidden bg-white shadow-dashboard px-8 pt-3 rounded-bl-lg rounded-br-lg">
                  <table className="w-full">
                    <thead>
                      <tr>
                        <th className="bg-gray-300 px-8 py-4  border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          #
                        </th>
                        <th className="bg-gray-300 px-8 py-4  border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          Judul
                        </th>
                        <th className="bg-gray-300 px-8 py-4  border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          Isi notifikasi
                        </th>
                        <th className="bg-gray-300 px-8 py-4  border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          Area
                        </th>
                        <th className="bg-gray-300 px-8 py-4  border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          Tanggal
                        </th>
                        <th className="bg-gray-300 px-8 py-4  border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          PIC
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white">
                      <tr>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500">
                          <div className="flex items-center">
                            <div>
                              <div className="text-sm leading-5 text-gray-800">
                                1
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500">
                          <div className="text-sm leading-5 text-gray-600">
                            Promosi gratis ongkir
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          Kamu tau ngga kalo OVO pay bisa digunakan alat
                          pertukaran tunai
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          Malang
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          20 Okt 2020
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500 text-gray-600 text-sm leading-5">
                          Kanzen
                        </td>
                      </tr>
                      <tr>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500">
                          <div className="flex items-center">
                            <div>
                              <div className="text-sm leading-5 text-gray-800">
                                2
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500">
                          <div className="text-sm leading-5 text-gray-600">
                            Promosi gratis ongkir
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          Kamu tau ngga kalo OVO pay bisa digunakan alat
                          pertukaran tunai
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          Malang
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          20 Okt 2020
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500 text-gray-600 text-sm leading-5">
                          Kanzen
                        </td>
                      </tr>
                      <tr>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500">
                          <div className="flex items-center">
                            <div>
                              <div className="text-sm leading-5 text-gray-800">
                                3
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500">
                          <div className="text-sm leading-5 text-gray-600">
                            Promosi gratis ongkir
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          Kamu tau ngga kalo OVO pay bisa digunakan alat
                          pertukaran tunai
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          Malang
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          20 Okt 2020
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500 text-gray-600 text-sm leading-5">
                          Kanzen
                        </td>
                      </tr>
                      <tr>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500">
                          <div className="flex items-center">
                            <div>
                              <div className="text-sm leading-5 text-gray-800">
                                4
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500">
                          <div className="text-sm leading-5 text-gray-600">
                            Promosi gratis ongkir
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          Kamu tau ngga kalo OVO pay bisa digunakan alat
                          pertukaran tunai
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          Malang
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          20 Okt 2020
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500 text-gray-600 text-sm leading-5">
                          Kanzen
                        </td>
                      </tr>
                      <tr>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500">
                          <div className="flex items-center">
                            <div>
                              <div className="text-sm leading-5 text-gray-800">
                                5
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500">
                          <div className="text-sm leading-5 text-gray-600">
                            Promosi gratis ongkir
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          Kamu tau ngga kalo OVO pay bisa digunakan alat
                          pertukaran tunai
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          Malang
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          20 Okt 2020
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500 text-gray-600 text-sm leading-5">
                          Kanzen
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="sm:flex-1 sm:flex sm:items-center sm:justify-between mt-4 work-sans float-right">
                    <div>
                      <nav className="relative z-0 inline-flex shadow-sm">
                        <div>
                          <a
                            href="/"
                            className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150"
                            aria-label="Previous"
                          >
                            Sebelumnya
                          </a>
                        </div>
                        <div>
                          <a
                            href="/"
                            className="-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm leading-5 font-medium text-green-700 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-tertiary active:text-gray-700 transition ease-in-out duration-150 hover:bg-tertiary"
                          >
                            1
                          </a>
                          <a
                            href="/"
                            className="-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm leading-5 font-medium text-green-600 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-tertiary active:text-gray-700 transition ease-in-out duration-150 hover:bg-tertiary"
                          >
                            2
                          </a>
                          <a
                            href="/"
                            className="-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm leading-5 font-medium text-green-600 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-tertiary active:text-gray-700 transition ease-in-out duration-150 hover:bg-tertiary"
                          >
                            3
                          </a>
                        </div>
                        <div>
                          <a
                            href="/"
                            className="-ml-px relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150"
                            aria-label="Next"
                          >
                            Selanjutnya
                          </a>
                        </div>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </LayoutDashboard>
    </>
  );
};

export default Notfication;
